import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import { AppStateStore } from "@/store/modules/appState";

@Component
export class CancelMix extends Vue {
    @Watch("$store.state.appState.sendCancel", { immediate: false })
    async ButtonCancel(): Promise<void> {
        AppStateStore.setCancel(false);
        await Vue.router.push({
            name: String(this.$routeRules.StoreOperations),
            params: {
                Studio: Vue.router.currentRoute.params["Studio"],
            },
        });
    }
}
